export const routes_names = {
  login: 'login',
  main: 'main',
  prompts: 'prompts',
  plans: 'plans',
}